shadow$provide[284] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, Spread:{enumerable:true, get:function() {
  return Spread;
}}});
var require$_DOT__SLASH_operator_DOT_js = require("./operator.js");
class Spread extends require$_DOT__SLASH_operator_DOT_js.Operator {
  static initClass() {
    this.traits = ["node", "bind", "operator", "source", "index", "spread"];
  }
  sourceShader(shader) {
    return shader.pipe(this.operator);
  }
  make() {
    super.make();
    if (this.bind.source == null) {
      return;
    }
    const uniforms = {spreadMatrix:this._attributes.make(this._types.mat4()), spreadOffset:this._attributes.make(this._types.vec4()),};
    this.spreadMatrix = uniforms.spreadMatrix;
    this.spreadOffset = uniforms.spreadOffset;
    const transform = this._shaders.shader();
    transform.require(this.bind.source.sourceShader(this._shaders.shader()));
    transform.pipe("spread.position", uniforms);
    return this.operator = transform;
  }
  unmake() {
    return super.unmake();
  }
  resize() {
    this.update();
    return super.resize();
  }
  update() {
    let key, i, k, v;
    const dims = this.bind.source.getFutureDimensions();
    const matrix = this.spreadMatrix.value;
    const els = matrix.elements;
    const order = ["width", "height", "depth", "items"];
    const align = ["alignWidth", "alignHeight", "alignDepth", "alignItems"];
    const {unit} = this.props;
    const unitEnum = this.node.attributes["spread.unit"].enum;
    const map = (() => {
      switch(unit) {
        case unitEnum.relative:
          return (key, i, k, v) => els[i * 4 + k] = v / Math.max(1, dims[key] - 1);
        case unitEnum.absolute:
          return (key, i, k, v) => els[i * 4 + k] = v;
      }
    })();
    return (() => {
      const result = [];
      for (i = 0; i < order.length; i++) {
        let offset;
        key = order[i];
        const spread = this.props[key];
        const anchor = this.props[align[i]];
        if (spread != null) {
          const d = dims[key] != null ? dims[key] : 1;
          offset = -(d - 1) * (0.5 - anchor * 0.5);
        } else {
          offset = 0;
        }
        this.spreadOffset.value.setComponent(i, offset);
        result.push((() => {
          const result1 = [];
          for (k = 0; k <= 3; k++) {
            let left;
            v = (left = spread != null ? spread.getComponent(k) : undefined) != null ? left : 0;
            result1.push(els[i * 4 + k] = map(key, i, k, v));
          }
          return result1;
        })());
      }
      return result;
    })();
  }
  change(changed, touched, _init) {
    if (touched["operator"]) {
      return this.rebuild();
    }
    if (touched["spread"]) {
      return this.update();
    }
  }
}
Spread.initClass();

};